import moment from "moment";
export const parseFieldsToState = (fields) =>
  fields.reduce((acum, el) => ({ ...acum, [el.name]: el.value }), {});

export const parseStateToFields = (state) => {
  // powerDate se maneja como string, no como moment
  const dateFields = ["dob", "emision", "expiration"];
  return Object.keys(state).map((key) => ({
    name: [key],
    value: dateFields.includes(key) ? moment(state[key]) : state[key],
  }));
};

export const parseDateFields = (data) => {
  // powerDate se maneja como string, no como moment
  const dateFields = ["dob", "emision", "expiration"];
  return Object.keys(data).reduce(
    (acum, el) => ({
      ...acum,
      [el]: dateFields.includes(el) ? moment(data[el]) : data[el],
    }),
    {}
  );
};
